import { loadReviews, loadReview, loadReviewRelationships } from "../common/api";

const model = {
    name: 'reviews',
    state: { 
        all: [], 
        current: {
            details: {},
            relationships: []
        },
        currentId: '',
        byId: {}
    },
    reducers: {
        setCurrentId: ( state, payload ) => {
            return {
                ...state,
                currentId: payload.rid
            }
        },
        cdcInsert: ( state, payload ) => {
            return {
                ...state,
                byId: {
                    ...state.byId,
                    [payload.rid]: { 
                        ...state.byId[payload.rid],
                        ...payload.cdc
                    }
                }
            }
        },
        cdcInsertAssoc: ( state, payload ) => {
            const [ rid, oid ] = payload.rid.split( '#' );
            let review = state.byId[rid];
            if ( !review ) {
                review = { rid: rid };
            }
            if ( !review.assoc ) {
                review.assoc = [];
            }
            review.assoc.push( payload.cdc );
            
            return {
                ...state,
                byId: {
                    ...state.byId,
                    [rid]: { 
                        ...review
                    }
                }
            }
        },
        cdcModify: ( state, payload ) => {
            return {
                ...state,
                byId: {
                    ...state.byId,
                    [payload.rid]: {
                        ...state.byId[payload.rid],
                        ...payload.cdc
                    }
                }
            }
        },
        cdcRemove: ( state, payload ) => {
            const keys = Object.keys( state.byId ).filter( f => f !== payload.rid );
            let newObj = {};
            keys.forEach( k => newObj[k] = state.byId[k] );
            return {
                ...state,
                byId: newObj
            }
        },
        cdcRemoveAssoc: ( state, payload ) => {
            const [ rid, cid ] = payload.rid.split( '#' );
            const review = state.byId[rid];
            const assoc = review.assoc.filter( f => f.cid !== cid );
            
            return {
                ...state,
                byId: {
                    ...state.byId,
                    [rid]: {
                        ...state.byId[rid],
                        assoc: assoc
                    }
                }
            }
        },
        loadedReviews: ( state, payload ) => {
            return {
                ...state,
                byId: {
                    ...state.byId,
                    ...payload
                }
            }
        },
        resetCurrent: ( state ) => {
            return {
                ...state,
                current: {
                    details: {},
                    relationships: []
                }
            }
        },
        loadedReview: ( state, payload ) => {
            return { 
                ...state,
                current: {
                    ...state.current,
                    details: payload
                }
            }
        },
        loadedReviewRelationships: ( state, payload ) => {
            return {
                ...state,
                current: {
                    ...state.current,
                    relationships: payload
                }
            }
        },
        loadedAll: ( state, payload ) => {
            return {
                ...state,
                all: [ ...payload ]
            }
        }
    },
    effects: ( dispatch ) => ( {
        async loadReview( { aid, uid, rid } ) {
            dispatch.reviews.resetCurrent();
            const r = await loadReview( aid, uid, rid );
            dispatch.reviews.loadedReview( r );
        },
        async loadReviewRelationships( { aid, uid, rid } ) {
            const r = await loadReviewRelationships( aid, uid, rid );
            dispatch.reviews.loadedReviewRelationships( r );
        },
        async loadReviews( { aid, uid } ) {
            const list = await loadReviews( aid, uid );
            let byId = {};
            list.forEach( r => byId[r.rid] = r );
            dispatch.reviews.loadedReviews( byId );
        },
        insert( { rid, cdc } ) {
            const assoc = rid.match( '#' );
            if ( assoc ) {
                dispatch.reviews.cdcInsertAssoc( { rid, cdc } );
            } else {
                dispatch.reviews.cdcInsert( { rid, cdc } );
            }
        },
        modify( { rid, cdc } ) {
            dispatch.reviews.cdcModify( { rid, cdc } );
        },
        remove( { rid } ) {
            const assoc = rid.match( '#' );
            if ( assoc ) {
                dispatch.reviews.cdcRemoveAssoc( { rid } );
            } else {
                dispatch.reviews.cdcRemove( { rid } );
            }
        },
        setCurrent( { rid } ) {
            dispatch.reviews.setCurrentId( { rid } );
        }
    } )
}

export default model;